import Dto from "../../../../../lib/model/service/Dto";

class UpdateCampaignStatus extends Dto {
  constructor(campaignId = '', status = '') {
    super('appl\\service\\campaign\\dto\\UpdateCampaignStatus');
    this.campaignId = campaignId;
    this.status = status;
  }
}

export default UpdateCampaignStatus;
